import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, removeWorkflowAction } from '../../reducers/actions';
import { WorkflowService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.DELETE_WORKFLOW),
    switchMap(action =>
      WorkflowService.delete(action.workflow, store).pipe(
        map(() => removeWorkflowAction(action.workflow)),
        catchError(retryAuthentication(action$, 'epics/workflows/deleteWorkflow'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/workflows/deleteWorkflow.js